const Privilege = {
  path: "",
  name: "",
  redirect: "/privilegecode",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/privilegecode",
      redirect: "/privilegecode",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Privilege",
      meta: {
        requiresAuth: true,
        activeUrl: "/privilegecode",
        parent: "privilegecode",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/privilegeCode/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/privilegecode",
            parent: "privilegecode",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Privilege Detail",
          component: () => import("@/views/pages/privilegeCode/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/privilegecode",
            parent: "privilegecode",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Privilege;
